import { Component, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { BaseAuthService } from '@shared/utils/base-auth';
import { Subject, take, takeUntil } from 'rxjs';
import { AppConfig } from '@shared/utils/app-config';

@Component({
    selector: 'feature-page-layout-microsoft-clarity-tracking',
    templateUrl: './microsoft-clarity-tracking.component.html',
    styleUrls: ['./microsoft-clarity-tracking.component.css'],
    standalone: false
})
export class MicrosoftClarityTrackingComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  constructor(public baseAuthService: BaseAuthService, private appConfig: AppConfig, private renderer2: Renderer2, private el: ElementRef) {}

  ngOnInit(): void {
    this.baseAuthService
      .getCurrentBaseUser()
      .pipe(take(1), takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (this.appConfig.production && this.appConfig.tracking.clarityId) {
          const microsoftClarityScript = this.renderer2.createElement('script');
          microsoftClarityScript.type = 'text/javascript';
          microsoftClarityScript.text = `
           (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
            var currentUserId =  '${x?.uid != null ? x.uid : null}' ;
            c[a]("identify", currentUserId);
           })(window, document, "clarity", "script", '${this.appConfig.tracking.clarityId}');`;

          this.renderer2.appendChild(this.el.nativeElement, microsoftClarityScript);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
